import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminSubscriptionContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBillingAddressBeUpdated!: boolean;

  @jsonMember(Boolean)
  public readonly canShippingAddressBeUpdated!: boolean;

  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeCancelled!: boolean;

  @jsonMember(Boolean)
  public readonly canBeProcessed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeSuspended!: boolean;

  @jsonMember(Boolean)
  public readonly canBeUpdated!: boolean;

  @jsonMember(Boolean)
  public readonly canBeResumed!: boolean;
}
